// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pl-0";
export var leftAlign = "_pl-4";
export var listItem = "_pl-2";
export var listItemWrapper = "_pl-1";
export var operationText = "_pl-3";